
const digest = '65f1e1f3325fc1054132b7614b5f0e79b34557958dda558c01cf892a19404864';
const classes = {"loadingWrapper":"_loadingWrapper_2uy0p_1","noDataMessage":"_noDataMessage_2uy0p_8"};
const css = `._loadingWrapper_2uy0p_1 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

._noDataMessage_2uy0p_8 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d81616;
  font-size: 14px;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  